import _ from 'lodash';

// constants
import { SCRIPT_URI_ADDON } from '../../../constants/constant';
import { SCRIPTS } from '../../../constants/section-constants/eventify-constant';
import { postRequest } from '../../Common/network-call';

export const MY_ITINERARY_LIST = 'MY_ITINERARY_LIST';

export const fetchMyItineraries = (
  session,
  extra = {},
  callback = () => {}
) => {
  const postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.getCommon.myItinerary.endpoint}`;
  const postBody = _.cloneDeep(SCRIPTS.getCommon.myItinerary.payload);

  return dispatch => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      res => {
        const payload = res?.resource || [];

        dispatch({ type: MY_ITINERARY_LIST, payload });
        callback && callback({ success: true, data: payload, error: null });
      },
      error => {
        callback && callback({ success: false, data: null, error });
      }
    );
  };
};
